define('views/content/customer_registration',['require','views/base/item_page_view','typeahead','bloodhound','models/customer_manager','text!templates/content/customer_registration.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');
    require('typeahead');
    require('bloodhound');

    var CustomerManagerModel = require('models/customer_manager');

    var temp = require("text!templates/content/customer_registration.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'login-wrapper',
        fullPage: true,

        afterInitialize: function () {
            // Add manager object to the model
            this.model.set('manager', new CustomerManagerModel().attributes);
            this.model.get('manager').password = '';
            this.model.get('manager').password_confirm = '';
            this.model.set('sector', App.context.constants.sectors[0].id);
        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                mainForm : '#main-form',
                submitButton: '#submit-button',

                cityField: '.cities-typeahead',
                currencyField: '.currency',
                districtField: '#district',

                companyName: '#company_name',
                companyLegalName: '#company_legal_name',
                licenseEmail: '#license_email',
                countrySelect: '#country',
                stateSelect: '#state',


                phoneCountrySelect: '#phone_country',
                managerPhoneCountrySelect: '#manager__phone_country',

                backButton: '#back-button',
                
                gdprLink: '#gdpr-link',
                kvkkLink: '#kvkk-link',
            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',

            'change @ui.companyName': 'companyNameChanged',
            'change @ui.licenseEmail': 'licenseEmailChanged',

            'click @ui.submitButton': 'submitButtonClicked',

            'change @ui.countrySelect': 'countryChanged',

            'click @ui.backButton': 'backButtonClicked',

            'click @ui.gdprLink': 'gdprLinklClicked',
            'click @ui.kvkkLink': 'kvkkLinkClicked'
        },

        afterRender: function () {
            var _this = this;
            // Setup typeahed for city field
            var citiesTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'cities/typeahead/',
                    replace: function(url, query) {
                        var modifiedUrl = url + ('?query=' + _this.ui.cityField.val());

                        if (_this.model.get('country')) {
                            modifiedUrl += ('&country=' + _this.model.get('country'));
                        }

                        return modifiedUrl;
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.cityField.typeahead({
                minLength: 3
            }, {
                name: 'cities',
                source: citiesTypeahedEngine,
                display: 'name'
            });

        },

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'license_email': "required",
                    'company_name': "required",
                    'sector': "required",
                    'country': "required",
                    'city_name': "required",
                    'phone_country': "required",
                    'phone_value': "required",
                    'address': "required",

                    'manager__first_name': "required",
                    'manager__last_name': "required",
                    'manager__phone_country': "required",
                    'manager__phone_value': "required",
                    'manager__password': "required",
                    'manager__password_confirm': {
                        equalTo: '[name="manager__password"]'
                    },
                    'currency': {maxlength: 10}

                },
                messages: {
                    'license_email': App.polyglot.t('email_required'),
                    'company_name': App.polyglot.t('company_name_required'),
                    'sector': App.polyglot.t('sector_required'),
                    'country': App.polyglot.t('country_required'),
                    'city_name': App.polyglot.t('city_required'),
                    'phone_country': App.polyglot.t('phone_country_required'),
                    'phone_value': App.polyglot.t('phone_value_required'),
                    'address': App.polyglot.t('address_required'),

                    'manager__first_name': App.polyglot.t('manager_first_name_required'),
                    'manager__last_name': App.polyglot.t('manager_last_name_required'),
                    'manager__phone_country': App.polyglot.t('manager_phone_country_required'),
                    'manager__phone_value': App.polyglot.t('manager_phone_value_required'),
                    'manager__password': App.polyglot.t('password_required'),
                    'manager__password_confirm': {
                        equalTo: App.polyglot.t('password_confirm_must_match')
                    },
                    "currency": {maxlength: App.polyglot.t('currency_max_length')},

                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

        beforeSubmit: function() {
            var country_id = this.ui.countrySelect.val();
            var selectedCountry = App.context.constants.countries.filter(function(x) {
                return x.id == country_id;
            })[0];

            if (selectedCountry.iso_code === 'TR') {
                if (!this.ui.districtField.val()) {
                    App.utils.showMessage('error', App.polyglot.t('district_required'));
                    return false;
                }
            }
            
            return true;
        },

       afterSuccess: function(response) {
           App.context.performLogin(response.manager_object);
           App.context.redirect('/signin');
           App.utils.showMessage('success', App.polyglot.t('registration_success'));
       },

        countryChanged: function () {
            var country_id = this.ui.countrySelect.val();

            if (country_id) {
                // Select same country in phone number field
                this.ui.phoneCountrySelect.val(country_id);
                this.ui.phoneCountrySelect.trigger('change');
                this.ui.managerPhoneCountrySelect.val(country_id);
                this.ui.managerPhoneCountrySelect.trigger('change');

                // Reset state and re render for state options of country
                this.ui.stateSelect.val(null);
                this.ui.stateSelect.trigger('change');
                this.render();

                // Set if country currency is available, otherwise set dollar as default
                var currency = App.context.constants.currencies.find(function(currency){
                    if(currency.country == country_id)
                        return currency;
                }) || {code: "DLR"};
                this.ui.currencyField.val(currency.code);

            }
        },


        licenseEmailChanged: function () {

            // auto chnage manager mail
            this.model.get('manager').email = this.ui.licenseEmail.val();
        },

        companyNameChanged: function () {
            this.model.set('company_legal_name', this.ui.companyName.val());
        },

        backButtonClicked: function () {
            window.history.back();
        },

        gdprLinklClicked: function (event) {
            window.open('https://gdpr.eu/tag/gdpr/', '_blank');
        },

        kvkkLinkClicked: function () {
            window.open('https://www.mevzuat.gov.tr/mevzuat?MevzuatNo=6698&MevzuatTur=1&MevzuatTertip=5', '_blank');
        }
    });
});
